/**
 * Erkennt den Fall „Migration Nr. 140 fehlt" an einem Schreibfehler auf
 * `quotes`: die Spalte `order_tranches` gibt es nicht (PostgREST PGRST204 /
 * Postgres 42703) oder der CHECK auf `quotes.status` kennt `partial` nicht
 * (23514).
 *
 * Wozu: die VOLLSTÄNDIGE Annahme muss auch dann weiter funktionieren, wenn
 * der Client vor dem SQL ausgerollt wurde (Lehre 02.09.2026, Nr. 68) — sie
 * schreibt dann wie bisher ohne Auftragsteil. Eine TEILbeauftragung geht ohne
 * die Migration nicht und bekommt eine klare Meldung statt eines Rohfehlers.
 */
export const isMissingOrderTranchesSchema = (err: unknown): boolean => {
    if (!err || typeof err !== 'object') return false;
    const e = err as { code?: unknown; message?: unknown; details?: unknown };
    const code = String(e.code ?? '');
    const text = `${String(e.message ?? '')} ${String(e.details ?? '')}`;
    if ((code === 'PGRST204' || code === '42703') && text.includes('order_tranches')) return true;
    if (code === '23514' && text.includes('quotes_status_check')) return true;
    return false;
};

export const MISSING_ORDER_TRANCHES_MESSAGE =
    'Teilbeauftragung ist in dieser Datenbank noch nicht eingerichtet (Migration Nr. 140 fehlt). '
    + 'Bitte die Migration ausführen oder das Angebot vollständig annehmen.';
